<template>
  <div>
    <v-alert type="success" outlined dense class="mb-4">
      Yenileme / geçiş işlemi tamamlandı. Başarıyla uygulanan, tamamlanamayan ve
      işleme alınmayan kayıtlar aşağıda özetleniyor.
    </v-alert>

    <v-row dense class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-sheet outlined rounded class="pa-3">
          <div class="text-caption text--secondary">Başarılı</div>
          <div class="text-h5 font-weight-bold success--text">
            {{ formatInteger(meta.success_total) }}
          </div>
        </v-sheet>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-sheet outlined rounded class="pa-3">
          <div class="text-caption text--secondary">Başarısız</div>
          <div class="text-h5 font-weight-bold error--text">
            {{ formatInteger(meta.failed_total) }}
          </div>
        </v-sheet>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-sheet outlined rounded class="pa-3">
          <div class="text-caption text--secondary">İşleme Alınmayan</div>
          <div class="text-h5 font-weight-bold warning--text">
            {{ formatInteger(meta.skipped_total) }}
          </div>
        </v-sheet>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-sheet outlined rounded class="pa-3">
          <div class="text-caption text--secondary">Denenen</div>
          <div class="text-h5 font-weight-bold">
            {{ formatInteger(meta.attempted_total) }}
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <v-card
      outlined
      class="mb-4 portfolio-transition-results-card portfolio-transition-results-card--success"
    >
      <v-card-title
        class="portfolio-transition-results-card__header"
        role="button"
        tabindex="0"
        @click="toggleSection('success')"
        @keydown.enter.prevent="toggleSection('success')"
        @keydown.space.prevent="toggleSection('success')"
      >
        <div class="portfolio-transition-results-card__header-copy">
          <div class="portfolio-transition-results-card__title">
            Başarılı İşlemler
          </div>
          <div class="portfolio-transition-results-card__subtitle">
            Başarıyla tamamlanan yenileme / geçiş işlemleri
          </div>
        </div>

        <v-spacer />

        <v-icon
          large
          class="portfolio-transition-results-card__toggle-icon"
          :class="{
            'portfolio-transition-results-card__toggle-icon--open':
              sections.success,
          }"
        >
          mdi-chevron-down
        </v-icon>
      </v-card-title>

      <v-expand-transition>
        <div v-show="sections.success">
          <v-data-table
            class="portfolio-transition-results-table"
            :headers="successHeaders"
            :items="successRows"
            dense
            :items-per-page="-1"
            mobile-breakpoint="0"
            no-data-text="Başarılı işlem bulunmuyor."
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.result_message="{ item }">
              <div>{{ item.result_message }}</div>
              <div class="text-caption text--secondary">
                {{
                  item.after_summary_label || item.resolved_rule_label || "-"
                }}
              </div>
            </template>

            <!-- eslint-disable-next-line -->
            <template v-slot:item.actions="{ item }">
              <div class="d-flex align-center justify-center">
                <rs-row-actions-menu :actions="getSuccessActions(item)" />
              </div>
            </template>
          </v-data-table>
        </div>
      </v-expand-transition>
    </v-card>

    <v-card
      outlined
      v-if="failedRows.length"
      class="mb-4 portfolio-transition-results-card portfolio-transition-results-card--failed"
    >
      <v-card-title
        class="portfolio-transition-results-card__header"
        role="button"
        tabindex="0"
        @click="toggleSection('failed')"
        @keydown.enter.prevent="toggleSection('failed')"
        @keydown.space.prevent="toggleSection('failed')"
      >
        <div class="portfolio-transition-results-card__header-copy">
          <div class="portfolio-transition-results-card__title">
            Başarısız İşlemler
          </div>
          <div class="portfolio-transition-results-card__subtitle">
            İşlem sırasında doğrulama veya güncel durum nedeniyle tamamlanamayan
            kayıtlar
          </div>
        </div>

        <v-spacer />

        <v-icon
          large
          class="portfolio-transition-results-card__toggle-icon"
          :class="{
            'portfolio-transition-results-card__toggle-icon--open':
              sections.failed,
          }"
        >
          mdi-chevron-down
        </v-icon>
      </v-card-title>

      <v-expand-transition>
        <div v-show="sections.failed">
          <v-data-table
            class="portfolio-transition-results-table"
            :headers="failedHeaders"
            :items="failedRows"
            dense
            :items-per-page="-1"
            mobile-breakpoint="0"
            no-data-text="Başarısız işlem bulunmuyor."
          />
        </div>
      </v-expand-transition>
    </v-card>

    <v-card
      outlined
      v-if="skippedRows.length"
      class="portfolio-transition-results-card portfolio-transition-results-card--skipped"
    >
      <v-card-title
        class="portfolio-transition-results-card__header"
        role="button"
        tabindex="0"
        @click="toggleSection('skipped')"
        @keydown.enter.prevent="toggleSection('skipped')"
        @keydown.space.prevent="toggleSection('skipped')"
      >
        <div class="portfolio-transition-results-card__header-copy">
          <div class="portfolio-transition-results-card__title">
            İşleme Alınmayan Kayıtlar
          </div>
          <div class="portfolio-transition-results-card__subtitle">
            Önizleme aşamasında işleme uygun bulunmadığı için uygulanmayan
            kayıtlar
          </div>
        </div>

        <v-spacer />

        <v-icon
          large
          class="portfolio-transition-results-card__toggle-icon"
          :class="{
            'portfolio-transition-results-card__toggle-icon--open':
              sections.skipped,
          }"
        >
          mdi-chevron-down
        </v-icon>
      </v-card-title>

      <v-expand-transition>
        <div v-show="sections.skipped">
          <v-data-table
            class="portfolio-transition-results-table"
            :headers="skippedHeaders"
            :items="skippedRows"
            dense
            :items-per-page="-1"
            mobile-breakpoint="0"
            no-data-text="İşleme alınmayan kayıt bulunmuyor."
          />
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PortfolioYearEndTransitionResultsStep",
  props: {
    resultData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      sections: {
        success: false,
        failed: false,
        skipped: false,
      },
      successHeaders: [
        {
          text: "Müşteri",
          value: "customer_name",
          sortable: false,
          align: "start",
        },
        {
          text: "Faturalandırma",
          value: "billing_type",
          sortable: false,
          width: "120px",
          align: "start",
        },
        {
          text: "Sonuç",
          value: "result_message",
          sortable: false,
          align: "start",
        },
        {
          text: "Aksiyonlar",
          value: "actions",
          sortable: false,
          align: "center",
          width: "72px",
        },
      ],
      failedHeaders: [
        {
          text: "Müşteri",
          value: "customer_name",
          sortable: false,
          align: "start",
        },
        {
          text: "Faturalandırma",
          value: "billing_type",
          sortable: false,
          width: "120px",
          align: "start",
        },
        {
          text: "Sebep",
          value: "result_message",
          sortable: false,
          align: "start",
        },
      ],
      skippedHeaders: [
        {
          text: "Müşteri",
          value: "customer_name",
          sortable: false,
          align: "start",
        },
        {
          text: "Faturalandırma",
          value: "billing_type",
          sortable: false,
          width: "120px",
          align: "start",
        },
        {
          text: "Sebep",
          value: "preview_reason",
          sortable: false,
          align: "start",
        },
      ],
    };
  },
  computed: {
    meta() {
      return (
        this.resultData?.meta || {
          attempted_total: 0,
          success_total: 0,
          failed_total: 0,
          skipped_total: 0,
        }
      );
    },
    successRows() {
      return this.resultData?.success_rows || [];
    },
    failedRows() {
      return this.resultData?.failed_rows || [];
    },
    skippedRows() {
      return this.resultData?.skipped_rows || [];
    },
  },
  methods: {
    toggleSection(key) {
      this.$set(this.sections, key, !this.sections[key]);
    },
    formatInteger(value) {
      return new Intl.NumberFormat("tr-TR", {
        maximumFractionDigits: 0,
      }).format(Number(value || 0));
    },
    resolveCustomerHref(item) {
      const customerId = Number(item?.customer_id || 0);

      if (customerId < 1) {
        return null;
      }

      return this.$router.resolve({
        name: "admin.crm.customers.edit",
        params: { id: customerId },
      }).href;
    },
    resolveInvoiceHref(item) {
      const invoiceId = Number(item?.invoice_id || 0);

      if (invoiceId < 1) {
        return null;
      }

      return this.$router.resolve({
        name: "admin.crm.customer-invoices.edit",
        params: { id: invoiceId },
      }).href;
    },
    getSuccessActions(item) {
      const actions = [];
      const customerHref = this.resolveCustomerHref(item);
      const invoiceHref = this.resolveInvoiceHref(item);

      if (customerHref) {
        actions.push({
          label: "Müşteriye Git",
          icon: "mdi-open-in-new",
          href: customerHref,
          target: "_blank",
        });
      }

      if (invoiceHref) {
        actions.push({
          label: "Faturaya Git",
          icon: "mdi-receipt-text-outline",
          href: invoiceHref,
          target: "_blank",
        });
      }

      return actions;
    },
  },
};
</script>

<style scoped>
.portfolio-transition-results-card {
  overflow: hidden;
}

.portfolio-transition-results-card__header {
  cursor: pointer;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  align-items: center;
}

.portfolio-transition-results-card__header-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.portfolio-transition-results-card--success {
  border-color: rgba(76, 175, 80, 0.16) !important;
}

.portfolio-transition-results-card--failed {
  border-color: rgba(244, 67, 54, 0.16) !important;
}

.portfolio-transition-results-card--skipped {
  border-color: rgba(255, 152, 0, 0.16) !important;
}

.portfolio-transition-results-card__title {
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 600;
}

.portfolio-transition-results-card__subtitle {
  font-size: 0.875rem;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.6);
}

.portfolio-transition-results-card--success
  .portfolio-transition-results-card__header {
  background: rgba(76, 175, 80, 0.1);
}

.portfolio-transition-results-card--failed
  .portfolio-transition-results-card__header {
  background: rgba(244, 67, 54, 0.1);
}

.portfolio-transition-results-card--skipped
  .portfolio-transition-results-card__header {
  background: rgba(255, 152, 0, 0.1);
}

.portfolio-transition-results-card__toggle-icon {
  transition: transform 0.2s ease;
}

.portfolio-transition-results-card__toggle-icon--open {
  transform: rotate(180deg);
}

.portfolio-transition-results-table :deep(th) {
  text-align: left !important;
}

.portfolio-transition-results-table :deep(th .v-data-table-header__content) {
  justify-content: flex-start !important;
  text-align: left !important;
}
</style>
